import { configureStore } from "@reduxjs/toolkit";
import {
  auth,
  loadSoicalMedias,
  users,
  loginCheck,
  login,
  categories,
  places,
  roles,
  loadClients,
  loadAllAppointments,
  googleReviews,
  featureLogo,
  clientsEndResult,
  dashboard,
  appointmentDetails,
  dashboardAppointments,
  youtubeVideos,
  draft,
  allPRPAppointments,
  allFUEAppointments,
  //medicines
  medicines,
  // notifications
  notifications,
  outhForm,
  printReceiptData,
  //services
  services,
  localpermissions,
} from "./action";
import { AllAppointments } from "./action";
const store = configureStore({
  reducer: {
    auth,
    loadSoicalMedias,
    users,
    loginCheck,
    login,
    categories,
    places,
    roles,
    loadClients,
    loadAllAppointments,
    googleReviews,
    featureLogo,
    clientsEndResult,
    dashboard,
    appointmentDetails,
    dashboardAppointments,
    youtubeVideos,
    allAppointments: AllAppointments,
    draft,
    allPRPAppointments,
    allFUEAppointments,
    //medicines
    medicines,
    //notifications
    notifications,
    outhForm,
    printReceiptData,
    //services
    services,
    // local permission
    localpermissions,
  },
});
export default store;
